import PropTypes from 'prop-types';
import CustomListNode from './CustomListNode';

export function CustomListItems({ nodes, path = [] }) {
  return (
    <div>
      {nodes.map((item, index) => {
        return (
          <CustomListNode
            key={item.id}
            nodeData={item}
            nodeIndex={index}
            path={path}
            renderChildNodes={() =>
              item.nodes?.length > 0 ? <CustomListItems path={[...path, item.id]} nodes={item.nodes} /> : null
            }
          />
        );
      })}
    </div>
  );
}

CustomListItems.propTypes = {
  nodes: PropTypes.array,
  path: PropTypes.array,
};
